module.exports = __webpack_public_path__ + "static/midway-notes-01-178b680718d717849968bb936fc02a48.png";